import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9bc68fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between flex-wrap gap-2" }
const _hoisted_2 = { class: "flex align-items-center gap-3 flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-color-secondary"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex align-items-center gap-2 flex-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm text-color-secondary white-space-nowrap",
  for: "solar-show-ts"
}, "Timestamp", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PInputSwitch = _resolveComponent("PInputSwitch")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PSelectButton = _resolveComponent("PSelectButton")!
  const _component_SolarChart = _resolveComponent("SolarChart")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createBlock(_component_PCard, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_WTitle, { text: "Solar Irradiation Readings" }),
          (_ctx.option === 'Data')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createTextVNode(" ~" + _toDisplayString(_ctx.total.toLocaleString()) + " records ", 1),
                (_ctx.pages > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "· ~" + _toDisplayString(_ctx.pages.toLocaleString()) + " pages", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.option === 'Data')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_PInputSwitch, {
                  inputId: "solar-show-ts",
                  modelValue: _ctx.showTimestamp,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTimestamp) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_PButton, {
            loading: _ctx.loading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh())),
            icon: "pi pi-refresh",
            label: "Refresh",
            rounded: "",
            size: "small",
            text: ""
          }, null, 8, ["loading"]),
          _createVNode(_component_PSelectButton, {
            allowEmpty: false,
            options: _ctx.options,
            "aria-labelledby": "basic",
            modelValue: _ctx.option,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.option) = $event)),
            onChange: _ctx.onOptionChange
          }, null, 8, ["options", "modelValue", "onChange"])
        ])
      ])
    ]),
    content: _withCtx(() => [
      (_ctx.option == 'Chart')
        ? (_openBlock(), _createBlock(_component_SolarChart, {
            data: _ctx.chartList,
            key: _ctx.chartKey
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (_ctx.option == 'Data')
        ? (_openBlock(), _createBlock(_component_PDataTable, {
            key: 1,
            alwaysShowPaginator: true,
            first: _ctx.first,
            highlightOnSelect: true,
            lazy: true,
            loading: _ctx.loading,
            resizableColumns: true,
            rowHover: true,
            rows: _ctx.rowsPerPage,
            rowsPerPageOptions: [50, 100, 200, 500],
            showGridlines: true,
            sortOrder: -1,
            stripedRows: true,
            style: _normalizeStyle(_ctx.paginatorStyle),
            totalRecords: _ctx.paginatorTotal,
            value: _ctx.list,
            currentPageReportTemplate: "{first}–{last} of ~{totalRecords}",
            "data-key": "id",
            paginator: "",
            paginatorPosition: "both",
            paginatorTemplate: "FirstPageLink PrevPageLink NextPageLink LastPageLink JumpToPageInput RowsPerPageDropdown CurrentPageReport",
            size: "small",
            sortField: "id",
            onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event))),
            class: "readings-table"
          }, {
            empty: _withCtx(() => [
              _createTextVNode("No records found.")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_PColumn, {
                bodyClass: "text-left",
                class: "justify-content-center",
                field: "id",
                header: "ID",
                headerClass: "py-3",
                style: {"width":"25px"}
              }),
              (_ctx.showTimestamp)
                ? (_openBlock(), _createBlock(_component_PColumn, {
                    key: 0,
                    bodyClass: "text-left",
                    class: "justify-content-center",
                    field: "ts",
                    header: "Timestamp",
                    headerClass: "py-3",
                    style: {"width":"160px"}
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_PColumn, {
                bodyClass: "text-left",
                class: "justify-content-center",
                field: "date",
                header: "Date",
                headerClass: "py-3",
                style: {"width":"200px"}
              }),
              _createVNode(_component_PColumn, {
                bodyClass: "text-left",
                class: "justify-content-center",
                field: "day",
                header: "Day",
                headerClass: "py-3",
                style: {"width":"200px"}
              }),
              _createVNode(_component_PColumn, {
                bodyClass: "text-left text-wrap",
                class: "justify-content-center",
                header: "Time",
                headerClass: "py-3",
                style: {"width":"120px"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatReadingTime(data)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PColumn, {
                bodyClass: "text-left",
                field: "value",
                header: "GPOAi",
                headerClass: "py-3",
                style: {"width":"200px"}
              })
            ]),
            _: 1
          }, 8, ["first", "loading", "rows", "style", "totalRecords", "value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}